module.exports = __webpack_public_path__ + "img/banner-9.4080ce00.jpg";